import {useRef} from 'react';

export const useShouldTrackProducts = (uniqueKey: string) => {
  const tracked = useRef(new Set<string>());

  const shouldDisableTrackProductImpression = (productId: number) => {
    return tracked.current.has(`${uniqueKey}-${productId}`);
  };

  const onProductImpressionTracked = (productId: number) => {
    tracked.current.add(`${uniqueKey}-${productId}`);
  };

  return {
    onProductImpressionTracked,
    shouldDisableTrackProductImpression,
  };
};
